import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Paper, Button, CardContent, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import mapInfoWindowStyles from './mapInfoWindowStyles'
import { setMarkerInfo } from '../../redux/myMapsSlice'
import { setPolylineStyle } from '../../../../utils/helpers'

const MapInfoWindow = ({ dispatch, isMobile }) => {
  const [campusImage, setCampusImage] = React.useState(null)
  const classes = mapInfoWindowStyles()
  const { markerInfo, selectedCampus, datasetLayer } = useSelector(
    (s) => s.maps,
  )
  const handleCloseMarkerInfo = () => {
    dispatch(setMarkerInfo({}))
    datasetLayer.style = setPolylineStyle
  }
  const chooseCampusImage = () => {
    let imageRef = null
    switch (selectedCampus) {
      case 'NEW BRUNSWICK':
        imageRef = {
          image: './assets/images/nb-campus.jpg',
          label: 'New Brunswick Campus',
        }
        break
      case 'NEWARK':
        imageRef = {
          image: './assets/images/nwk-campus.jpg',
          label: 'Newark Campus',
        }
        break
      case 'CAMDEN':
        imageRef = {
          image: './assets/images/cmd-campus.jpg',
          label: 'Camden Campus',
        }
        break
      default:
        imageRef = {
          image: './assets/images/nb-campus.jpg',
          label: 'New Brunswick Campus',
        }
    }
    setCampusImage(imageRef)
  }
  React.useEffect(() => {
    chooseCampusImage(selectedCampus)
  }, [selectedCampus])
  if (isMobile) return null
  return (
    <>
      {markerInfo && Object.keys(markerInfo).length !== 0 ? (
        <Paper className={classes.mapInfoContainer} variant="outlined">
          <CardContent>
            <div className={classes.mapInfoCardContentContainer}>
              <div className={classes.campusContainer}>
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.campusImageText}
                >
                  {campusImage ? campusImage.label : ''}
                </Typography>
              </div>
              <div className={classes.campusImageContainer}>
                {campusImage ? (
                  <img
                    src={campusImage.image}
                    alt="New Brunswick Campus"
                    className={classes.campusImage}
                  />
                ) : (
                  <Skeleton width={250} height={154} />
                )}
              </div>
            </div>
            <Typography variant="subtitle1" className={classes.campusText}>
              {markerInfo?.Lot}
            </Typography>
            <Typography variant="body2" className={classes.campusText}>
              {markerInfo['Address 1']}
            </Typography>
            <Typography variant="body2" className={classes.campusText}>
              {markerInfo['City Code']}
            </Typography>
          </CardContent>
          <Box className={classes.mapInfoButtonContainer}>
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={handleCloseMarkerInfo}
            >
              Close
            </Button>
          </Box>
        </Paper>
      ) : null}
    </>
  )
}

export default MapInfoWindow
